/**
 * Интерфейс только русский — i18n-библиотека намеренно не подключается.
 * Все пользовательские строки живут здесь.
 */
export const ru = {
  appName: 'SayfAzkari',

  home: {
    subtitle: 'Время для поминания Аллаха',
    start: 'Начать',
    resume: 'Продолжить',
    done: 'Прочитано сегодня',
    settings: 'Настройки',
    streakOne: 'день подряд',
    streakFew: 'дня подряд',
    streakMany: 'дней подряд',
  },

  /** Подписи полей времени в настройках — не приветствия */
  reminders: {
    morning: 'Утренние азкары',
    evening: 'Вечерние азкары',
  },

  session: {
    of: 'из',
    times: 'раз',
    remaining: 'осталось',
    tapToCount: 'Нажимайте для отсчёта',
    source: 'Источник',
    fadl: 'Достоинство',
    next: 'Далее',
    finish: 'Завершить',
    exit: 'На главную',
    exitHint: 'Выйти на главный экран',
  },

  salawat: {
    title: 'Салават Пророку ﷺ',
    cardSubtitle: 'Счёт без предела, сохраняется между заходами',
    tapToCount: 'Нажимайте для отсчёта',
    today: 'Сегодня',
    total: 'Всего',
    resetToday: 'Обнулить сегодняшний счёт',
    noText:
      'Текст салавата пока не добавлен — счётчик работает без него. ' +
      'Арабский текст должен прийти из выверенного источника.',
  },

  credit: {
    by: 'Разработал',
    username: 'weexew',
  },

  complete: {
    title: 'Азкары прочитаны',
    subtitleMorning: 'Утренние азкары завершены',
    subtitleEvening: 'Вечерние азкары завершены',
    streak: 'Дней подряд',
    totalRead: 'Наборов прочитано',
    toHome: 'На главную',
  },

  settings: {
    title: 'Настройки',
    theme: 'Тема',
    themeAuto: 'Автоматически',
    themeMorning: 'Утренняя',
    themeEvening: 'Вечерняя',
    arabicSize: 'Размер арабского текста',
    showTranslit: 'Показывать транскрипцию',
    showTranslation: 'Показывать перевод',
    reminders: 'Напоминания',
  },

  unverifiedWarning:
    'Тексты — временная заглушка для разработки и не выверены. Не используйте для чтения.',
} as const;
